import React from 'react';
import styled from 'styled-components';

import { mediumMediaQuery, largeMediaQuery, smallMediaQuery } from '../../../../common/utilities/sizeHelpers';
import { CopyrightFooter } from '../../copyrightFooter';
import { PageFooterContinentList } from './pageFooterContinentList';
import { PageFooterStatesList } from './pageFooterStateList';
import type { IStoreState } from '../../../common/interfaces/types';
import { reduxConnect } from '../../../../common';

type FooterColophonSectionProps = {
    enableNewFooterUIWithCMPIntegration: boolean;
}

const mapStoreStateToProps = (storeState: IStoreState) => {
    const { enableNewFooterUIWithCMPIntegration } = storeState?.appState?.appState || {};

    return {
        enableNewFooterUIWithCMPIntegration
    };
};

const mapDispatchToProps = {};

export const FooterColophonSection = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(({ enableNewFooterUIWithCMPIntegration }: FooterColophonSectionProps) => {
    return (
        <ColophonWrapper enableNewFooterUIWithCMPIntegration={enableNewFooterUIWithCMPIntegration} >
            <CopyrightFooter />
            <ColophonTopStatesContainer>
                <PageFooterStatesList /> 
                <PageFooterContinentList />
            </ColophonTopStatesContainer>
        </ColophonWrapper>
    );
});

FooterColophonSection.displayName = 'FooterColophonSection';

type ColophonWrapperProps = {
    enableNewFooterUIWithCMPIntegration: boolean;
}
const ColophonWrapper = styled.div<ColophonWrapperProps>`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: ${({ enableNewFooterUIWithCMPIntegration }) => enableNewFooterUIWithCMPIntegration ? '7px 0' : '36px 0'};
    font-size: 0;
    width: 100%;
    text-align: center;
    background-color: #2f6f8c;
    @media ${mediumMediaQuery} {
        ${({ enableNewFooterUIWithCMPIntegration }) => enableNewFooterUIWithCMPIntegration 
        ? 'padding: 9px 0;'
        : 'padding: 36px 0;'}
    }

    @media ${smallMediaQuery} {
        ${({ enableNewFooterUIWithCMPIntegration }) => enableNewFooterUIWithCMPIntegration 
        ? 'padding: 36px 16px;'
        : ''}
    }
`;

const ColophonTopStatesContainer = styled.div`
    @media ${largeMediaQuery}{
        display: flex;
        flex-direction: column;
        width: 100%;
        font-size: 16px;
        font-weight: 400;
        line-height: 1.25;
        color: rgba(white, .5);
        margin: 25px auto;
        max-width: 780px;
    }
`;